import HeaderNone from './../../components/component/header/header_none.jsx';

import TermsAndConditionComponent from './../../components/component/t-&-c_components/t-&-c.jsx';


import FooterNone from './../../components/component/footer/footer_none.jsx'
import LaptopFooter from './../../components/component/footer/laptop_footer.jsx';



function TermsAndConditions() {
    return (
            <main>
                <HeaderNone />
                <TermsAndConditionComponent />

                <FooterNone />
                <LaptopFooter />

            </main>
    );
}

export default TermsAndConditions;

